import { useQuery } from "@tanstack/react-query";
import { marketFinderSubmissionsService } from "@/features/submissions/services/submissions.service";
import type { EmailDocumentRead } from "@/features/submissions/types/submissions.types";

export const emailDocumentKeys = {
  root: ["email-documents"] as const,
  list: (appId: number) => ["email-documents", appId] as const,
};

export function useEmailDocumentsQuery(appId: number, enabled = true) {
  return useQuery<EmailDocumentRead[]>({
    queryKey: emailDocumentKeys.list(appId),
    queryFn: () => marketFinderSubmissionsService.listEmailDocuments(appId),
    enabled: enabled && Number.isFinite(appId),
    staleTime: 30 * 1000,
  });
}
